import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import {
  getListWebBetaCompletedUser,
  updateUserStatus,
  updateBetaUserStatus
} from "../../store/actions/user-profile.actions";
import {
  getNextPageFromURL,
  flattenQueryResults,
} from "../../utils/utils";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Avatar from "react-avatar";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { getUserFullName } from "../../utils/commons";
const WebsiteBetaCompletedUsers = () => {
  const { changeBackground, background } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState();
  const [newProject, setNewProject] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [datePeriod, setDatePeriod] = useState();
  const [suspenseUser, setSuspenseUser] = useState();
  const today = moment();
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const calendaricon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
    >
      <mask id="ipSApplication0">
        <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
          <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
          <path
            fill="#fff"
            d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
          ></path>
        </g>
      </mask>
      <path
        fill="currentColor"
        d="M0 0h48v48H0z"
        mask="url(#ipSApplication0)"
      ></path>
    </svg>
  );
  const columns = [
    "ID",
    "Profile",
    "Name",
    "Email",
    "Phone",
    "Beta Code",
    "Status",
    "Action",
  ];

  const {
    data = { pages: [] },
    isFetching: adminUsersListFetching,
    isLoading: adminUsersListLoading,
    refetch: refetchAdminUsersList,
    fetchNextPage: adminUsersListFetchNextPage,
    hasNextPage: adminUsersListHasNextPage,
    hasPreviousPage: adminUsersListHasPrevPage,
    fetchPreviousPage: adminUsersListFetchPrevPage,
  } = useInfiniteQuery({
    queryKey: ["beta-completed-users-list", searchQuery],
    queryFn: async ({ queryKey, pageParam }) => {
      const resp = (
        await dispatch(getListWebBetaCompletedUser({ pageParam, search: queryKey?.[1] }))
      )?.payload;
      return resp;
    },
    getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
    getPreviousPageParam: (lastPage) => getNextPageFromURL(lastPage?.previous),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    refetchAdminUsersList();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      refetchAdminUsersList();
    }
  }, [searchQuery]);

  const sort = 10;

  const activePag = useRef(0);

  const allUsers = flattenQueryResults(data) ?? [];

  const getUserStatusMessage = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return { message: "Active", state: "success" };
      case 'verified':
        return { message: "Verified", state: "success" };
      case 'pending':
        return { message: "Pending", state: "info" };
      case 'unverified':
        return { message: "Unverified", state: "info" };
      case 'deleted':
        return { message: "Deleted", state: "dark" };
      case 'banned':
        return { message: "Banned", state: "danger" };
      case 'suspended':
        return { message: "Suspended", state: "warning" };
      case 'rejected':
        return { message: "Rejected", state: "danger" };
      case 'completed':
        return { message: "Completed", state: "success" };
      default:
        return { message: status, state: "info" };
    }
  };

  const handleChangeStatus = (action, id) => {
    if (action === "SUSPENDED") {
      setNewProject(true);
      setSuspenseUser(id);
    } else {
      dispatch(updateBetaUserStatus({status: action, user_id: id}))
      .then((res) => {
        if (res.payload.message) {
          refetchAdminUsersList();
          toast.success(res.payload.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
          });
          setNewProject(false);
          setSuspenseUser();
        } else {
          toast.error("Something went wrong!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
          });
        }
      });
    }
  };

  const handleSuspendUser = () => {
    dispatch(
      updateUserStatus({
        action: "SUSPENDED", //SUSPENDED //BANNED
        suspended_till: datePeriod
          ? moment(datePeriod).utc().format()
          : moment(startDate).utc().format(),
        user_id: suspenseUser,
      })
    ).then((res) => {
      if (res.payload.message) {
        refetchAdminUsersList();
        toast.success(res.payload.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });
        setNewProject(false);
        setSuspenseUser();
      } else {
        toast.error("Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
      setDatePeriod();
      setStartDate(new Date());
    });
  };

  return (
    <Fragment>
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Beta Completed Users</h4>
          </div>
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <div id="example_filter" class="dataTables_filter">
                  <label>
                    Search:
                    <input
                      type="search"
                      class=""
                      placeholder=""
                      aria-controls="example"
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </label>
                </div>
                {adminUsersListFetching || adminUsersListLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <table id="example3" className="display w-100 dataTable">
                    <thead>
                      <tr role="row">
                        {columns.map((d, i) => (
                          <th key={i}>{d}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {allUsers?.length ? (
                        allUsers?.map((d, i) => (
                          <tr key={i}>
                            <Fragment key={i}>
                              <td>{d?.id}</td>
                              <td>
                                <Avatar
                                  size="40"
                                  round={true}
                                  name={`${d?.first_name} ${d?.last_name}`}
                                  src={d?.profile_pic}
                                />
                              </td>
                              <td>{`${d?.first_name} ${d?.last_name}`}</td>
                              <td>{d?.email}</td>
                              <td>{d?.phone_number}</td>
                              <td>{d?.code}</td>
                              <td>
                                <span
                                  className={`badge badge-rounded badge-${
                                    getUserStatusMessage(d?.status)?.state
                                  }`}
                                >
                                  {getUserStatusMessage(d?.status)?.message}
                                </span>
                              </td>
                              <td>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant={
                                      getUserStatusMessage(d?.status)?.state
                                    }
                                    className="light sharp i-false"
                                  >
                                    {svg1}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleChangeStatus("pending", d?.id)
                                      }
                                    >
                                      Pending
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleChangeStatus("rejected", d?.id)
                                      }
                                    >
                                      Rejected
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleChangeStatus("verified", d?.id)
                                      }
                                    >
                                      Verified
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleChangeStatus("completed", d?.id)
                                      }
                                    >
                                      Completed
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </Fragment>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={columns.length} className="text-center">
                            No completed beta users found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr role="row">
                        {columns.map((d, i) => (
                          <th key={i}>{d}</th>
                        ))}
                      </tr>
                    </tfoot>
                  </table>
                )}
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                  <div className="dataTables_info">
                    Showing {activePag.current * sort + 1} to {allUsers?.length}{" "}
                    of {data?.pages[0]?.count} entries
                  </div>
                  <div className="dataTables_paginate paging_simple_numbers">
                    <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    >
                      {adminUsersListHasPrevPage && (
                        <Link
                          className="paginate_button previous disabled"
                          onClick={() => adminUsersListFetchPrevPage()}
                        >
                          Previous
                        </Link>
                      )}

                      {adminUsersListHasNextPage && (
                        <Link
                          className="paginate_button next"
                          onClick={() => adminUsersListFetchNextPage()}
                        >
                          Next
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="modal fade"
        size="md"
        id="addProjectSidebar"
        show={newProject}
        onHide={setNewProject}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select suspension period</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setNewProject(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="text-black font-w500">Select Period</label>
              <select
                onChange={(e) => setDatePeriod(e.target.value)}
                placeholder="Select Period"
                className="form-control"
              >
                <option>Choose period</option>
                <option value={moment().add(1, "week").format()}>1 Week</option>
                <option value={moment().add(1, "month").format()}>
                  1 Month
                </option>
                <option value={moment().add(1, "year").format()}>1 Year</option>
              </select>
            </div>
            <div className="d-flex justify-content-center">OR</div>
            <div className="form-group date-picker-full">
              <label className="text-black font-w500">Pick a date</label>
              <br />
              <DatePicker
                showIcon
                icon={calendaricon}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control w-100"
                dateFormat="MM-dd-yyyy"
                minDate={new Date()}
              />
            </div>
            <div className="form-group">
              <button
                onClick={() => handleSuspendUser()}
                className="btn btn-primary"
              >
                Suspend
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};
export default WebsiteBetaCompletedUsers;